export default __webpack_public_path__ + "static/media/dm-signup.80a8dbbc.svg";